/**
 * Builds the link a vendor hands to a client. That link is served by the
 * separate portal front end (`ev-portal-app`), not this app, so its origin has
 * to be configured here rather than derived from window.location.
 *
 * Defaults to the local portal dev server so the dashboard shows a usable link
 * with no .env set up.
 */
const PORTAL_ORIGIN = (
  process.env.REACT_APP_PRIVATE_PORTAL_ORIGIN || "http://localhost:3001"
).replace(/\/$/, "");

/**
 * Whether the portal has a real home to link to.
 *
 * A production build without REACT_APP_PRIVATE_PORTAL_ORIGIN falls back to the
 * localhost default above, which would have vendors mailing their customers a
 * link to their own machine — so the dashboard hides the feature instead of
 * offering a dead one. Development keeps it, where that fallback is the actual
 * portal dev server.
 */
export const privatePortalConfigured =
  Boolean(process.env.REACT_APP_PRIVATE_PORTAL_ORIGIN) ||
  process.env.NODE_ENV === "development";

export const vendorPortalUrl = (slug: string): string =>
  `${PORTAL_ORIGIN}/${slug}`;
